import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import Footers from '../components/footers';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'flowbite-react';
import { AiOutlineLoading } from 'react-icons/ai';
import { serverURL } from '../constants';
import axios from 'axios';
import { toast } from 'react-toastify';

const Topics = () => {

    const { state } = useLocation();
    const [processing, setProcessing] = useState(false);
    const [step, setStep] = useState('');
    const [elapsed, setElapsed] = useState(0);
    const { jsonData, mainTopic, type, lang } = state || {};

    const navigate = useNavigate();

    useEffect(() => {
        if (!processing) { setElapsed(0); return; }
        const start = Date.now();
        const id = setInterval(() => setElapsed(Math.floor((Date.now() - start) / 1000)), 200);
        return () => clearInterval(id);
    }, [processing]);

    useEffect(() => {

        if (!jsonData) {
            navigate("/create");
        }

    }, []);

    function redirectCreate() {
        navigate("/create");
    }

    const showToast = async (msg) => {
        toast(msg, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        });
    }


    function redirectCourse() {

        const mainTopicData = jsonData[mainTopic][0];

        const firstSubtopic = mainTopicData.subtopics[0];

        if (type === 'video & text course') {

            const query = `${firstSubtopic.title} ${mainTopic}`;
            setProcessing(true);
            setStep('Searching YouTube video...');
            sendVideo(query, firstSubtopic.title);

        } else {

            const prompt = `Strictly in ${lang}, Explain me about this subtopic of ${mainTopic} with examples :- ${firstSubtopic.title}. Please Strictly Don't Give Additional Resources And Images.`;
            const promptImage = `${firstSubtopic.title}`;
            setProcessing(true);
            setStep('Generating lesson content...');
            sendPrompt(prompt, promptImage);

        }

    }

    async function sendPrompt(prompt, promptImage, attempt = 0) {
        if (attempt >= 2) {
            setProcessing(false);
            toast.error('Failed to generate content. Please try again.');
            return;
        }
        const dataToSend = {
            prompt: prompt,
        };
        try {
            const postURL = serverURL + '/api/generate';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.text;
            sendImage(generatedText, promptImage);
        } catch (error) {
            sendPrompt(prompt, promptImage, attempt + 1)
        }
    }

    async function sendImage(parsedJson, promptImage, attempt = 0) {
        setStep('Finding a good image...');
        if (attempt >= 2) {
            // Continue without image
            sendData(`https://placehold.co/600x400?text=${encodeURIComponent(promptImage.slice(0, 30))}`, parsedJson);
            return;
        }
        const dataToSend = {
            prompt: promptImage,
        };
        try {
            const postURL = serverURL + '/api/image';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.url;
            sendData(generatedText, parsedJson);
        } catch (error) {
            sendImage(parsedJson, promptImage, attempt + 1)
        }
    }

    async function sendData(image, theory, attempt = 0) {
        setStep('Saving your course...');
        if (attempt >= 2) {
            setProcessing(false);
            toast.error('Failed to save course. Please try again.');
            return;
        }
        jsonData[mainTopic][0].subtopics[0].theory = theory;
        jsonData[mainTopic][0].subtopics[0].image = image;

        const user = sessionStorage.getItem('uid');
        const content = JSON.stringify(jsonData);
        const postURL = serverURL + '/api/course';
        try {
            const response = await axios.post(postURL, { user, content, type, mainTopic, lang });
            if (response.data.success) {
                setProcessing(false);
                showToast(response.data.message);
                sessionStorage.setItem('courseId', response.data.courseId);
                sessionStorage.setItem('first', response.data.completed);
                sessionStorage.setItem('jsonData', JSON.stringify(jsonData));
                navigate('/course', { state: { jsonData: jsonData, mainTopic: mainTopic.toUpperCase(), type: type.toLowerCase(), courseId: response.data.courseId, end: '', pass: false, lang } });
            } else {
                sendData(image, theory, attempt + 1)
            }
        } catch (error) {
            sendData(image, theory, attempt + 1)
        }
    }

    async function sendDataVideo(image, theory, attempt = 0) {
        setStep('Saving your course...');
        if (attempt >= 2) {
            setProcessing(false);
            toast.error('Failed to save course. Please try again.');
            return;
        }
        jsonData[mainTopic][0].subtopics[0].theory = theory;
        jsonData[mainTopic][0].subtopics[0].youtube = image;

        const user = sessionStorage.getItem('uid');
        const content = JSON.stringify(jsonData);
        const postURL = serverURL + '/api/course';
        try {
            const response = await axios.post(postURL, { user, content, type, mainTopic, lang });
            if (response.data.success) {
                setProcessing(false);
                showToast(response.data.message);
                sessionStorage.setItem('courseId', response.data.courseId);
                sessionStorage.setItem('first', response.data.completed);
                sessionStorage.setItem('jsonData', JSON.stringify(jsonData));
                navigate('/course', { state: { jsonData: jsonData, mainTopic: mainTopic.toUpperCase(), type: type.toLowerCase(), courseId: response.data.courseId, end: '', pass: false, lang } });
            } else {
                sendDataVideo(image, theory, attempt + 1)
            }
        } catch (error) {
            sendDataVideo(image, theory, attempt + 1)
        }
    }

    async function sendVideo(query, subtopic, attempt = 0) {
        if (attempt >= 2) {
            setProcessing(false);
            toast.error('Failed to fetch video. Please try again.');
            return;
        }
        const dataToSend = {
            prompt: query,
        };
        try {
            const postURL = serverURL + '/api/yt';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.url;
            sendTranscript(generatedText, subtopic);
        } catch (error) {
            sendVideo(query, subtopic, attempt + 1)
        }
    }

    async function sendTranscript(url, subtopic, attempt = 0) {
        setStep('Fetching video transcript...');
        if (attempt >= 2) {
            const prompt = `Strictly in ${lang}, Explain me about this subtopic of ${mainTopic} with examples :- ${subtopic}. Please Strictly Don't Give Additional Resources And Images.`;
            sendSummery(prompt, url);
            return;
        }
        const dataToSend = {
            prompt: url,
        };
        try {
            const postURL = serverURL + '/api/transcript';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.url;
            try {
                const allText = generatedText.map(item => item.text);
                const concatenatedText = allText.join(' ');
                const prompt = `Strictly in ${lang}, Summarize this theory in a teaching way and :- ${concatenatedText}.`;
                sendSummery(prompt, url);
            } catch (error) {
                const prompt = `Strictly in ${lang}, Explain me about this subtopic of ${mainTopic} with examples :- ${subtopic}. Please Strictly Don't Give Additional Resources And Images.`;
                sendSummery(prompt, url);
            }
        } catch (error) {
            const prompt = `Strictly in ${lang}, Explain me about this subtopic of ${mainTopic} with examples :- ${subtopic}. Please Strictly Don't Give Additional Resources And Images.`;
            sendSummery(prompt, url);
        }
    }

    async function sendSummery(prompt, url, attempt = 0) {
        setStep('Summarizing video into lesson...');
        if (attempt >= 2) {
            setProcessing(false);
            toast.error('Failed to generate summary. Please try again.');
            return;
        }
        const dataToSend = {
            prompt: prompt,
        };
        try {
            const postURL = serverURL + '/api/generate';
            const res = await axios.post(postURL, dataToSend);
            const generatedText = res.data.text;
            sendDataVideo(url, generatedText);
        } catch (error) {
            sendSummery(prompt, url, attempt + 1)
        }
    }

    const renderTopicsAndSubtopics = (topics) => {
        try {
            return (
                <div>
                    {topics.map((topic) => (
                        <div key={topic.title}>
                            <h3 className='w-full text-white bg-black px-4 py-2 mt-8 mb-2 font-black text-lg dark:bg-white dark:text-black'>{topic.title}</h3>
                            <div>
                                {topic.subtopics.map((subtopic) => (
                                    <p className='w-full border-black border bg-white px-4 py-2 mb-2 font-normal text-sm dark:text-white dark:border-white dark:bg-black' key={subtopic.title}>{subtopic.title}</p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            );
        } catch (error) {
            return (
                <div>
                    {topics.map((topic) => (
                        <div key={topic.title}>
                            <h3 className='w-full text-white bg-black px-4 py-2 mt-8 mb-2 font-black text-lg dark:bg-white dark:text-black'>{topic.title}</h3>
                            <div>
                                {topic.subtopics.map((subtopic) => (
                                    <p className='w-full border-black border bg-white px-4 py-2 mb-2 font-normal text-sm dark:text-white dark:border-white dark:bg-black' key={subtopic.title}>{subtopic.title}</p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            );
        }
    };


    return (
        <div className='h-screen flex flex-col'>
            <Header isHome={true} className="sticky top-0 z-50" />
            <div className='dark:bg-black flex-1'>
                <div>
                    <div className='max-md:max-w-sm max-sm:max-w-xs max-w-lg m-auto py-10'>
                        <h1 style={{ textTransform: 'uppercase' }} className='text-4xl text-black font-black text-center dark:text-white' >{mainTopic}</h1>
                        <p className='text-center font-bold mt-2 text-base text-black dark:text-white'>List of topics and subtopics course will cover</p>
                        {jsonData && renderTopicsAndSubtopics(jsonData[mainTopic])}
                        <Button onClick={redirectCourse} isProcessing={processing} processingSpinner={<AiOutlineLoading className="h-6 w-6 animate-spin" />} className='items-center justify-center text-center dark:bg-white dark:text-black bg-black text-white font-bold rounded-none w-full enabled:hover:bg-black enabled:focus:bg-black enabled:focus:ring-transparent dark:enabled:hover:bg-white dark:enabled:focus:bg-white dark:enabled:focus:ring-transparent mt-10 mb-2'>Generate Course</Button>
                        <Button onClick={redirectCreate} type="button" className='mb-6 items-center justify-center text-center border-black dark:border-white dark:bg-black dark:text-white bg-white text-black font-bold rounded-none w-full enabled:hover:bg-white enabled:focus:bg-white enabled:focus:ring-transparent dark:enabled:hover:bg-black dark:enabled:focus:bg-black dark:enabled:focus:ring-transparent'>Go Back</Button>
                    </div>

                </div>
            </div>
            {processing && (
                <div className='fixed inset-0 bg-black/70 backdrop-blur-sm z-[100] flex items-center justify-center p-4'>
                    <div className='bg-white dark:bg-gray-900 rounded-2xl shadow-2xl max-w-md w-full p-8 text-center'>
                        <div className='inline-flex items-center justify-center w-16 h-16 rounded-full bg-black dark:bg-white mb-4'>
                            <AiOutlineLoading className='h-8 w-8 animate-spin text-white dark:text-black' />
                        </div>
                        <h3 className='text-xl font-black text-black dark:text-white mb-1'>Generating your course</h3>
                        <p className='text-sm text-gray-500 dark:text-gray-400 mb-5'>This usually takes 30–60 seconds</p>
                        <div className='bg-gray-50 dark:bg-black rounded-lg p-4 mb-4'>
                            <p className='text-sm font-bold text-black dark:text-white mb-1'>{step || 'Starting...'}</p>
                            <p className='text-xs text-gray-400'>Elapsed: {elapsed}s</p>
                        </div>
                        <div className='text-left space-y-1.5'>
                            <p className='text-[11px] text-gray-500'>📝 Only the first lesson is generated now. Other lessons load on-demand when you click them — this saves credits.</p>
                        </div>
                    </div>
                </div>
            )}
            <Footers className="sticky bottom-0 z-50" />
        </div>
    );
};

export default Topics;